
import { useFormContext } from "react-hook-form";
import { DynFormProps } from "..";
import { useCallback, useState } from "react";
import { TDadosPropriedade, TOpenModalPropriedade } from "../../../screens/Financeiro/components/SolicitarAnaliseCredito/FormSolicitacao/DadosPropriedade";
import DisplayListPropriedades from "../../../screens/Financeiro/components/SolicitarAnaliseCredito/FormSolicitacao/DadosPropriedade/DisplayListPropriedades";
import AgricultureOutlinedIcon from '@mui/icons-material/AgricultureOutlined';
import DialogFormDadosPropriedade from "../../../screens/Financeiro/components/SolicitarAnaliseCredito/FormSolicitacao/DadosPropriedade/DialogFormDadosPropriedade";
import { Box } from "@mui/material";

export default function DynDadosPropriedade({ spec }: DynDadosPropriedadeProps) {
    const { getValues, watch, setValue } = useFormContext();

    const [openModal, setOpenModal] = useState<TOpenModalPropriedade>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", index?: number | null, value?: TDadosPropriedade | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && typeof index === "number" && value) {setOpenModal({ open: true, index, defaultValue: value })}
        if (action === "open" && !index && !value) setOpenModal({ open: true, index: null, defaultValue: null })
    }, [])
    //

    const propriedades: TDadosPropriedade[] = watch(`${spec.name}.propriedades`) || [];

    const handleAdicionarPropriedade = (data: TDadosPropriedade) => {
        const currentPropriedades = getValues(`${spec.name}.propriedades`) || [];
        const updatedPropriedades: TDadosPropriedade[] = [...currentPropriedades, data];
        setValue(`${spec.name}.propriedades`, updatedPropriedades);
        handleModalAction("close");
    }

    const handleEditarPropriedade = (index: number, item: TDadosPropriedade) => {
        const currentPropriedades = getValues(`${spec.name}.propriedades`) || [];
        const updatedPropriedades: TDadosPropriedade[] = currentPropriedades.map((prop: TDadosPropriedade, i: number): TDadosPropriedade => i === index ? item : prop);
        setValue(`${spec.name}.propriedades`, updatedPropriedades);
        handleModalAction("close");
    }

    const handleDeletePropriedade = (index: number) => {
        const currentPropriedades = getValues(`${spec.name}.propriedades`) || [];
        const updatedPropriedades: TDadosPropriedade[] = currentPropriedades.filter((_: TDadosPropriedade, i: number) => i !== index);
        setValue(`${spec.name}.propriedades`, updatedPropriedades);
    }

    return (
        <Box mb={2}>
            <DisplayListPropriedades
                items={propriedades}
                handleOpenDialog={() => {
                    handleModalAction("open", undefined, null)
                }}
                handleDeleteItem={handleDeletePropriedade}
                handleEditItem={(item, index) => {
                    handleModalAction("open", index, item);
                }}
                emptyListMessage="Nenhuma fazenda adicionada"
                linkButtonText="Adicionar fazenda"
                linkButtonIcon={
                    <AgricultureOutlinedIcon sx={{ color: "#1b5e20" }} />
                }
            />
            {
                Boolean(openModal?.open) &&
                <DialogFormDadosPropriedade
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    onClose={() => handleModalAction("close")}
                    onSubmit={(data) => {
                        if (typeof openModal?.index === "number") {
                            handleEditarPropriedade(openModal?.index, data);
                            return;
                        }
                        handleAdicionarPropriedade(data);
                    }}
                />
            }
        </Box>
    )
}

interface DynDadosPropriedadeProps extends DynFormProps {}
